/* Kairii notification buttons hand off to STOQ. Unavailable services never imply a subscription. */
(function () {
  'use strict';
  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('kr-notify-data').textContent); } catch (e) {}
  var I = cfg.i18n || {};
  var decoder = document.createElement('textarea');
  Object.keys(I).forEach(function (key) { decoder.innerHTML = I[key]; I[key] = decoder.value; });
  var modal = document.querySelector('[data-kr-notify-modal]');
  var scrim = document.querySelector('[data-kr-notify-scrim]');
  var title = modal && modal.querySelector('[data-kr-notify-title]');
  var sub = modal && modal.querySelector('[data-kr-notify-sub]');
  var retry = modal && modal.querySelector('[data-kr-notify-retry]');
  var close = modal && modal.querySelector('[data-kr-notify-close]');
  var pending = null;

  function context(button) {
    return {
      productId: button.getAttribute('data-kr-product') || '',
      variantId: button.getAttribute('data-kr-variant') || '',
      handle: button.getAttribute('data-kr-handle') || '',
      kind: button.getAttribute('data-kr-kind') || 'restock',
      title: button.getAttribute('data-kr-title') || ''
    };
  }
  function handoff(ctx) {
    var app = window._RestockRocket;
    if (ctx.kind === 'preorder_slip' || !ctx.productId || !ctx.variantId || !app || typeof app.openModal !== 'function') return false;
    try {
      app.openModal({
        id: Number(ctx.productId), title: ctx.title, handle: ctx.handle,
        variants: [{ id: Number(ctx.variantId), available: false }]
      }, String(ctx.variantId), cfg.customerEmail ? { email: cfg.customerEmail } : undefined);
      return true;
    } catch (error) { return false; }
  }
  function hide(restoreFocus) {
    if (modal) modal.hidden = true;
    if (scrim) scrim.hidden = true;
    document.documentElement.classList.remove('kr-notify-open');
    if (restoreFocus && pending) pending.focus();
    pending = null;
  }
  function unavailable(button, ctx) {
    if (!modal) {
      var message = button.nextElementSibling;
      if (!message || !message.hasAttribute('data-kr-notify-error')) {
        message = document.createElement('p');
        message.setAttribute('data-kr-notify-error', '');
        message.setAttribute('role', 'status');
        button.insertAdjacentElement('afterend', message);
      }
      message.textContent = I.unavailable || I.error;
      return;
    }
    pending = button;
    title.textContent = I.unavailableTitle;
    sub.textContent = ctx.kind === 'preorder_slip' ? I.slipUnavailable : I.unavailable;
    retry.hidden = ctx.kind === 'preorder_slip';
    modal.hidden = false;
    if (scrim) scrim.hidden = false;
    document.documentElement.classList.add('kr-notify-open');
    if (close) close.focus();
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-kr-notify]');
    if (button) {
      event.preventDefault();
      event.stopPropagation();
      var ctx = context(button);
      if (!handoff(ctx)) unavailable(button, ctx);
      return;
    }
    if (event.target.closest && event.target.closest('[data-kr-notify-close], [data-kr-notify-scrim]')) hide(true);
  });
  if (retry) retry.addEventListener('click', function () {
    var button = pending;
    if (!button) return;
    var ctx = context(button);
    hide(false);
    if (!handoff(ctx)) unavailable(button, ctx);
  });
  document.addEventListener('keydown', function (event) {
    if (!modal || modal.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); hide(true); return; }
    if (event.key !== 'Tab') return;
    var controls = Array.from(modal.querySelectorAll('button, a[href]')).filter(function (el) { return !el.hidden && !el.disabled && el.getClientRects().length; });
    var first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
})();

